import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59897070"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bank-account" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-2" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "cards mt-4"
}
const _hoisted_5 = {
  key: 2,
  class: "cards mt-4"
}
const _hoisted_6 = { style: {"width":"100%","text-align":"right"} }

export function render(_ctx, _cache) {
  const _component_BankCard = _resolveComponent("BankCard")
  const _component_BankCardV2 = _resolveComponent("BankCardV2")
  const _component_AddBankModal = _resolveComponent("AddBankModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.qWording), 1),
    (_ctx.formType !== 'EER')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode("At least one bank account is required to proceed ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.questionTypeId == _ctx.QuestionType.PerBankAccount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (b, idx) => {
            return (_openBlock(), _createBlock(_component_BankCard, {
              onRemoveBankAccount: $event => (_ctx.removeBankAccount(idx)),
              onValidFormBank: $event => (_ctx.validFormBank(idx, $event)),
              bank: _ctx.banks[idx],
              "onUpdate:bank": $event => ((_ctx.banks[idx]) = $event),
              formType: _ctx.formType,
              "onUpdate:formType": _cache[0] || (_cache[0] = $event => ((_ctx.formType) = $event))
            }, null, 8, ["onRemoveBankAccount", "onValidFormBank", "bank", "onUpdate:bank", "formType"]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (_ctx.questionTypeId == _ctx.QuestionType.PerBankAccountV2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (b, idx) => {
            return (_openBlock(), _createBlock(_component_BankCardV2, {
              onRemoveBankAccount: $event => (_ctx.removeBankAccount(idx)),
              onValidFormBank: $event => (_ctx.validFormBank(idx, $event)),
              bank: _ctx.banks[idx],
              "onUpdate:bank": $event => ((_ctx.banks[idx]) = $event),
              formType: _ctx.formType,
              "onUpdate:formType": _cache[1] || (_cache[1] = $event => ((_ctx.formType) = $event))
            }, null, 8, ["onRemoveBankAccount", "onValidFormBank", "bank", "onUpdate:bank", "formType"]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.formType !== 'EER')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-secondary sml",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.addNewBankAccount()))
          }, "Add new bank"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showNewBankModal)
      ? (_openBlock(), _createBlock(_component_AddBankModal, {
          key: 3,
          onClose: _cache[3] || (_cache[3] = $event => (_ctx.showNewBankModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
}